var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWatchTutorial = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.333 9.733L11.46 8l1.873-1.733v3.466zM10 10.666c0 .368-.299.667-.667.667h-6c-.368 0-.667-.299-.667-.667V5.333c0-.367.299-.667.667-.667h6c.368 0 .667.3.667.667v5.333zm4.008-5.902c-.418-.182-.902-.103-1.234.204L11.333 6.3v-.968c0-1.103-.897-2-2-2h-6c-1.103 0-2 .897-2 2v5.333c0 1.104.897 2 2 2h6c1.103 0 2-.896 2-2V9.7l1.44 1.333c.214.198.49.301.773.301.156 0 .312-.031.462-.097.406-.177.658-.556.658-.989V5.753c0-.433-.252-.812-.658-.99z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWatchTutorial, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/watch_tutorial.bae332c8.svg";
export { ForwardRef as ReactComponent };